export function Toast({
    variant,
    message,
    visible,
}: {
    variant: string;
    message: string;
    visible: boolean;
}) {
    return (
        <div className="toast toast-top toast-end">
            {visible ? (
                <div
                    className={
                        variant == "Error"
                            ? "alert alert-error"
                            : variant == "Success"
                            ? "alert alert-success"
                            : "alert alert-info"
                    }
                >
                    <span>{message}</span>
                </div>
            ) : (
                <></>
            )}
        </div>
    );
}
